import { Component, OnInit } from '@angular/core';
import { Departamento } from '@app/_models';
import { Router, NavigationEnd } from "@angular/router"

import { DepartamentosService } from '@app/_services/departamentos.service';

import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { MenuService } from '../_services';

@Component({
  selector: 'app-departamentos',
  templateUrl: './departamentos.component.html',
})
export class DepartamentosComponent implements OnInit {


  public seleccionados: number[] = [];
  private translate: TranslateService;
  public dataDepartamentos: [];
  modalReference: NgbModalRef;
  modalReferenceloading: NgbModalRef;
  closeResult = '';
  navigationSubscription;
  lang;

  constructor(private departamentosService: DepartamentosService,
    translate: TranslateService,
    private menuService: MenuService, public router: Router,
    private translateService: TranslateService,
    private modalService: NgbModal) {

    this.translate = translate;
    this.menuService.titulo = this.translate.instant('departamentos.departamentos').toUpperCase();

    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      // If it is a NavigationEnd event re-initalise the component
      if (e instanceof NavigationEnd) {
        if (this.router.url == '/departamentos') {
          this.menuService.titulo = this.translateService.instant('departamentos.departamentos');
          this.departamentosService.GetAll().subscribe((result) => {
            this.dataDepartamentos = result.data;
          }
          );
        } else {
         
        }
      }
    });
  }

  ngOnInit(): void {
    this.departamentosService.GetAll().subscribe((result) => {
      this.dataDepartamentos = result.data;
      }
    );
    this.lang = this.translateService.getDefaultLang();
    this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.lang = this.translateService.currentLang;
      this.menuService.titulo = this.translateService.instant('departamentos.departamentos');
    });
  }

  onClickNuevo() {
    this.router.navigate(['departamentos/crear/']);
  }

  onClickEditar() {
    if (this.seleccionados[0] > 0) {
      this.router.navigate(['departamentos/editar/', this.seleccionados[0]]);
    }
  }

  cellClick(e) {
    if (e.columnIndex > 0) {
      this.router.navigate(['departamentos/editar/', this.seleccionados[0]]);
    }
  }

  onClickEliminar(content) {
    if (this.seleccionados.length > 0) {
      this.modalReference = this.modalService.open(content, { backdrop: 'static', size: 'lg', keyboard: false, centered: true });
    }
  }

  private eliminarRegistro(contentloading) {
    this.departamentosService.delete({ codigos: this.seleccionados }).subscribe(
      (data) => {
        if (data.error == false) {
          this.departamentosService.GetAll().subscribe((result) => {
            this.dataDepartamentos = result.data;
          }
          );
        }
        this.modalReferenceloading.close();
      }
    );
    this.modalReference.close();
    this.modalReferenceloading = this.modalService.open(contentloading, { backdrop: 'static', size: 'sm', keyboard: false, centered: true });
    this.seleccionados = [];
  }


}

